import { calculateBrandEmail, calculateBrandName } from '@alluradirect/react';
import { dvLogo, logoInvert } from './imageUrls';

export const calculateBrandLogo = (isDV: boolean, isGuestApp: boolean): string =>
  isDV && isGuestApp ? dvLogo : logoInvert;

interface Args {
  isDV: boolean;
  isGuestApp: boolean;
}

export function isDirectVacations({ isDV, isGuestApp }: Args): boolean {
  return isDV && isGuestApp;
}

export function brandInfo(isDV: boolean, isGuestApp: boolean) {
  const isDv = isDirectVacations({ isDV, isGuestApp });
  const brandName = calculateBrandName(isDv);
  const brandEmail = calculateBrandEmail(isDv);
  const brandLogo = calculateBrandLogo(isDV, isGuestApp);

  return {
    isDV: isDv,
    brandName,
    brandEmail,
    brandLogo,
  };
}
